
import React, { useEffect, useState } from "react";
import { Spinner, Badge, Button, Dropdown, Nav } from "react-bootstrap";
import { toast } from "sonner";
import styles from "./outlook.module.css";
import imgs from "../../../Utils/assets/img/faces/5.jpg";
import ComposeModal from "./ComposeModal";
import {
  faEllipsisVertical,
  faMailForward,
  faRefresh,
  faReply,
  faReplyAll,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteModal from "../../DeleteModal";
import { formatDate, formatTime } from "../../../Utils/helpers/commonhelper";
import { baseURL } from "../../../Utils/constants/constant";
import { PostRequest } from "../../../Utils/hooks/ApiHandler";

export default function OutlookMails() {
  const [folder, setFolder] = useState("inbox");
  const [mails, setMails] = useState([]);
  const [selectedMail, setSelectedMail] = useState(null);
  const [threadMails, setThreadMails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [threadLoading, setThreadLoading] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [composeOpen, setComposeOpen] = useState(false);
  const [composeType, setComposeType] = useState("new");
  const [deleting, setDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteModal1, setShowDeleteModal1] = useState(false);
  const [designationToDelete, setDesignationToDelete] = useState(null);
  const [search, setSearch] = useState("");

  const accessToken = sessionStorage.getItem("email_access_token");
  const userEmail = sessionStorage.getItem("user_email");

  /* ============ LOAD MAILS ============ */
  // const loadMails = async () => {
  //   setLoading(true);
  //   setSelectedMail(null);
  //   setThreadMails([]);

  //   const res = await fetch(`${baseURL}inbox/mails`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ accessToken, folder }),
  //   });

  //   setMails(await res.json());
  //   setLoading(false);
  // };


  const loadMails = async () => {
  try {
    setLoading(true);
    setSelectedMail(null);
    setThreadMails([]);

    const res = await PostRequest(
      `${baseURL}inbox/mails`,
      { accessToken, folder },
      false,
      {},
      {}
    );
    setMails(res?.data || []);
  } catch (err) {
    console.error("Mail load failed", err);
    toast.error("Failed to load mails");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    loadMails();
  }, [folder]);

  /* ============ OPEN THREAD ============ */
  // const openThread = async (mail) => {
  //   setSelectedMail(mail);
  //   setThreadMails([]);
  //   setThreadLoading(true);

  //   const res = await fetch(`${baseURL}inbox/conversation`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       accessToken,
  //       conversationId: mail.conversationId,
  //     }),
  //   });

  //   setThreadMails(await res.json());
  //   setThreadLoading(false);
  // };


  const openThread = async (mail) => {
  try {
    setSelectedMail(mail);
    setThreadMails([]);
    setThreadLoading(true);
    
    const res = await PostRequest(
      `${baseURL}inbox/conversation`,
      {
        accessToken,
        conversationId: mail?.conversationId,
      },
      false,
      {},
      {}
    );

    setThreadMails(res?.data || []);
  } catch (err) {
    console.error("Thread load failed", err);
    toast.error("Failed to load conversation");
  } finally {
    setThreadLoading(false);
  }
};

  /* ============ DELETE ============ */
  const onDelete = (ids) => {
    setDesignationToDelete(ids);
    setShowDeleteModal1(true);
  };

  // const deleteMails = async (ids) => {
  //   setDeleting(true);

  //   await fetch(`${baseURL}inbox/delete`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ accessToken, ids }),
  //   });

  //   setDeleting(false);
  //   toast.success("Deleted");
  //   setShowDeleteModal1(false);
  //   setShowDeleteModal(false);
  //   setDesignationToDelete(null);
  //   setSelectedIds([]);
  //   loadMails();
  // };


  const deleteMails = async (ids) => {
  try {
    setDeleting(true);

    await PostRequest(
      `${baseURL}inbox/delete`,
      { accessToken, ids },
      false,
      {},
      {}
    );

    toast.success("Deleted");

    setShowDeleteModal1(false);
    setShowDeleteModal(false);
    setDesignationToDelete(null);
    setSelectedIds([]);

    await loadMails();
  } catch (err) {
    console.error("Delete failed", err);
    toast.error("Delete failed");
  } finally {
    setDeleting(false);
  }
};

  /* ============ REPLY RECIPIENTS ============ */
  // const getReplyRecipients = (type) => {
    

    const getReplyRecipients = (type) => {
  if (!selectedMail) return [];

  const me = (userEmail || "").toLowerCase();

  const from = selectedMail?.from?.emailAddress?.address || "";

  const to =
    selectedMail?.toRecipients
      ?.map(r => r?.emailAddress?.address || "")
      .filter(Boolean) || [];

  const cc =
    selectedMail?.ccRecipients
      ?.map(r => r?.emailAddress?.address || "")
      .filter(Boolean) || [];

  if (type === "reply") return from ? [from] : [];

  if (type === "replyAll") {
    const all = [from, ...to, ...cc];
    return [...new Set(all)].filter(e => e.toLowerCase() !== me);
  }

  return [];
};

    
  //   if (!selectedMail) return [];
   
  //   const from = selectedMail?.from?.emailAddress?.address || "";
      
  //   const to =
  //     selectedMail?.toRecipients
  //       ?.map((r) => r.emailAddress?.address)
  //       .filter(Boolean) || [];

  //   const cc =
  //     selectedMail?.ccRecipients
  //       ?.map((r) => r.emailAddress?.address)
  //       .filter(Boolean) || [];

  //   if (type === "reply") return from ? [from] : [];

  //   if (type === "replyAll") {
  //     const all = [from, ...to, ...cc];
  //     return all.filter(
  //       (email) => email && email.toLowerCase() !== userEmail.toLowerCase()
  //     );
  //   }

  //   return []; // forward
  // };
//   const getReplyRecipients = (type) => {
//   if (!selectedMail) return [];

//   const me = (userEmail || "").toLowerCase();

//   const from = selectedMail?.from?.emailAddress?.address || "";

//   const to =
//     selectedMail?.toRecipients
//       ?.map(r => r?.emailAddress?.address || "")
//       .filter(Boolean) || [];

//   const cc =
//     selectedMail?.ccRecipients
//       ?.map(r => r?.emailAddress?.address || "")
//       .filter(Boolean) || [];

//   if (type === "reply") {
//     return from ? [from] : [];
//   }

//   if (type === "replyAll") {
//     const all = [from, ...to, ...cc];

//     return [...new Set(all)].filter(
//       email => email && email.toLowerCase() !== me
//     );
//   }

//   return [];
// };

  
  
  const getOriginalMessage = () => {
  if (!threadMails || !threadMails.length) return null;
  return threadMails[threadMails.length - 1]; // latest full email
};

  /* ============ QUICK REPLY ============ */
  // const sendReply = async () => {
  //   if (!replyText.trim()) return;

  //   await fetch(`${baseURL}inbox/reply`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       accessToken,
  //       messageId: selectedMail.id,
  //       comment: replyText,
  //     }),
  //   });

  //   setReplyText("");
  //   openThread(selectedMail);
  //   loadMails();
  // };


  /* ============ QUICK REPLY ============ */
const sendReply = async () => {
  if (!replyText.trim()) return;

  try {
    await PostRequest(
      `${baseURL}inbox/reply`,
      {
        accessToken,
        messageId: selectedMail.id,
        comment: replyText,
      },
      true,
      {},
      {}
    );

    setReplyText("");
    await openThread(selectedMail);
    await loadMails();
  } catch (err) {
    console.error("Reply failed", err);
    toast.error("Reply failed");
  }
};

  const toList = selectedMail?.toRecipients
    ?.map((r) => r.emailAddress.address)
    .join(", ");

  return (
    <>
      {/* <ComposeModal
        open={composeOpen}
        type={composeType}
        mail={selectedMail}
        recipients={getReplyRecipients(composeType)}
        onClose={() => setComposeOpen(false)}
      /> */}

      <ComposeModal
  open={composeOpen}
  type={composeType}
  mail={selectedMail}              
  originalMail={getOriginalMessage()} 
  recipients={getReplyRecipients(composeType)}
  onClose={() => setComposeOpen(false)}
/>


      <DeleteModal
        show={showDeleteModal1}
        onClose={() => !deleting && setShowDeleteModal1(false)}
        onConfirm={() => deleteMails(designationToDelete)}
        loading={deleting}
        message="Are you sure you want to delete this email ?"
      />

      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => deleteMails(selectedIds)}
        loading={deleting}
        message="Are you sure you want to delete all selected email ?"
      />

      <div className="d-flex" style={{ height: "calc(100vh )" }}>
        <div className={styles.container}>
          {/* Left Sidebar */}
          <div className="d-flex flex-column" style={{ width: "16%" }}>
            <div
              className="bg-white rounded border p-3"
              style={{ height: "100%" }}
            >
              <button
                className="btn btn-success w-100 fw-semibold"
                onClick={() => setComposeOpen(true)}
              >
                + Compose Mail
              </button>
              <hr />

              <div className="p-3">
                <div className="text-muted fw-semibold small mb-2">MAILS</div>

                <div className="nav flex-column gap-2">
                  {[
                    {
                      key: "all",
                      label: "All Mails",
                      // count: counts.total,
                      badge: "bg-success-subtle text-success",
                    },
                    {
                      key: "inbox",
                      label: "Inbox",
                      // count: counts.inbox,
                      badge: "bg-primary-subtle text-primary",
                    },
                    {
                      key: "sent",
                      label: "Sent",
                      // count: counts.sent,
                      badge: "bg-secondary-subtle text-secondary",
                      icon: "✈️",
                    },
                  ].map((item) => (
                    <button
                      key={item.key}
                      className={`nav-link d-flex align-items-center justify-content-between ${
                        folder === item.key ? "active" : ""
                      }`}
                      onClick={() => setFolder(item.key)}
                    >
                      <span className="d-flex align-items-center">
                        {item.icon && (
                          <span
                            className="me-2"
                            style={{ transform: "rotate(-45deg)" }}
                          >
                            {item.icon}
                          </span>
                        )}
                        {item.label}
                      </span>

                      <span className={`badge ${item.badge} fw-semibold`}>
                        {item.count}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* MIDDLE SECTION */}
          <div
            className="d-flex flex-column bg-white rounded border"
            style={{ width: "32%" }}
          >
            {/* Header */}

            {/* Header Section */}
            <div className="p-3 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    mails.length > 0 && selectedIds.length === mails.length
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedIds(mails.map((m) => m.id));
                    } else {
                      setSelectedIds([]);
                    }
                  }}
                />
                <span className="fw-semibold text-capitalize">
                  {folder === "sent"
                    ? "Sent"
                    : folder === "inbox"
                    ? "Inbox"
                    : "All Mails"}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-outline-secondary"
                  // onClick={() => fetchThreadList()}
                  // disabled={!isConnected}
                  title="Refresh"
                >
                  <FontAwesomeIcon icon={faRefresh} />
                </button>

                <div
                  style={{
                    display: `${!selectedIds.length ? "none" : "block"}`,
                  }}
                >
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => setShowDeleteModal(true)}
                    disabled={!selectedIds.length}
                    title="Delete Selected"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </div>
            </div>
            <hr className="m-0" />

            {/* Search Section */}
            <div className="px-3 py-3">
              <form
                className="d-flex gap-2"
                onSubmit={(e) => {
                  e.preventDefault();
                  // fetchThreadList();
                }}
              >
                <input
                  className="form-control"
                  placeholder="Search Email"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <button className="btn btn-outline-secondary" type="submit">
                  Search
                </button>
              </form>
            </div>

            <hr className="m-0 p-0" />

            {/* Mail List */}
            <div
              className="flex-grow-1 overflow-auto"
              style={{ height: "65vh" }}
            >
              {loading ? (
                <div className="p-4 text-center">Loading…</div>
              ) : !mails.length ? (
                <p className="text-muted text-center my-4">No Emails Found</p>
              ) : (
                mails.map((mail) => {
                  const isSent =
                    mail.from?.emailAddress?.address?.toLowerCase() ===
                    userEmail?.toLowerCase();
                  const isActive = selectedMail?.id === mail.id;

                  return (
                    <div
                      key={mail.id}
                      className={`px-3 py-2 border-bottom d-flex align-items-center justify-content-between ${
                        isActive ? "bg-light" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center gap-3 w-100">
                        {/* Checkbox */}
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={selectedIds.includes(mail.id)}
                          onChange={() =>
                            setSelectedIds((prev) =>
                              prev.includes(mail.id)
                                ? prev.filter((i) => i !== mail.id)
                                : [...prev, mail.id]
                            )
                          }
                        />

                        {/* Mail Content */}
                        <div
                          className="rounded-circle bg-secondary-subtle"
                          style={{ width: 36, height: 36 }}
                          onClick={() => openThread(mail)}
                        >
                          <img
                            src={imgs}
                            style={{
                              width: 36,
                              height: 36,
                              borderRadius: "50%",
                            }}
                            className="rounded-circel"
                          />
                        </div>
                        <div
                          className="flex-grow-1"
                          onClick={() => openThread(mail)}
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <strong
                              className="text-truncate"
                              style={{ maxWidth: "70%", fontSize: "13px" }}
                            >
                              {mail.from?.emailAddress?.address || "Unknown"}
                            </strong>

                            <span
                              className={`badge ${
                                isSent
                                  ? "bg-primary-subtle text-primary"
                                  : "bg-success-subtle text-success"
                              }`}
                            >
                              {isSent ? "Sent" : "Inbox"}
                            </span>
                          </div>

                          <div
                            className="text-dark text-truncate"
                            style={{ fontSize: "14px" }}
                          >
                            <span className="fs-13 fw-500">Subject :</span>
                            {mail.subject
                              ? mail.subject.replace(/^PUG_CRM\s*/i, "")
                              : "(No Subject)"}{" "}
                            {/* <span className="ms-2">{formatDate(mail?.sentDateTime)}</span>
                            <span className="ms-2">
                              {formatTime(
                                new Date(mail?.sentDateTime).toLocaleTimeString(
                                  [],
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  }
                                )
                              )}
                            </span> */}
                          </div>
                        </div>
                        <div className="d-flex flex-column align-items-end">
                          <small className="text-muted fs-10 mb-2">
                            {formatTime(
                              new Date(mail?.sentDateTime).toLocaleTimeString(
                                [],
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )
                            )}
                          </small>
                          <button
                            className="btn btn-sm"
                            title="Delete"
                            onClick={(e) => {
                              onDelete([mail.id]);
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="text-danger"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>

          {/* RIGHT */}
          {/* <div className={styles.thread}>
        {!selectedMail ? (
          <div className={styles.empty}>Select an email</div>
        ) : threadLoading ? (
          <Spinner />
        ) : (
          <>
            <h6>{selectedMail.subject}</h6>

            {threadMails.map((m) => (
              <div key={m.id} className={styles.threadMsg}>
                <strong>{m.from?.emailAddress?.address}</strong>
                <div className={styles.preview}>{m.bodyPreview}</div>
              </div>
            ))}

            <textarea
              rows="3"
              placeholder="Reply..."
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
            />

            <Button size="sm" onClick={sendReply}>
              Send
            </Button>
          </>
        )}
      </div> */}

          {/* RIGHT SECTION */}
        

          {/* RIGHT SECTION */}
<div className="d-flex flex-column" style={{ width: "52%" }}>
  <div className="bg-white rounded border px-3 pb-2 pt-3 flex-grow-1 overflow-auto">

    {!selectedMail ? (
      <div className="h-100 d-flex align-items-center justify-content-center text-muted">
        Select an email
      </div>
    ) : threadLoading ? (
      <div className="text-center p-4">Loading…</div>
    ) : (
      <>
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center pb-3 border-bottom">
          <div className="d-flex align-items-center gap-2">
            <img
              src={imgs}
              alt=""
              style={{ width: 36, height: 36, borderRadius: "50%" }}
            />
            <div>
              <h6 className="mb-0">
                {selectedMail?.from?.emailAddress?.address || "Unknown Sender"}
              </h6>
              <small className="text-muted">
                {(selectedMail?.subject || "")
                  .replace(/\bPUG_CRM\b/gi, "")
                  .replace(/^(Re:|Fwd:)+/gi, "")
                  .trim()}
              </small>
            </div>
          </div>

          <Dropdown>
            <Dropdown.Toggle as={Nav.Link}>
              <FontAwesomeIcon icon={faEllipsisVertical} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => { setComposeType("reply"); setComposeOpen(true); }}>
                <FontAwesomeIcon icon={faReply} className="me-2" /> Reply
              </Dropdown.Item>
              <Dropdown.Item onClick={() => { setComposeType("replyAll"); setComposeOpen(true); }}>
                <FontAwesomeIcon icon={faReplyAll} className="me-2" /> Reply All
              </Dropdown.Item>
              <Dropdown.Item onClick={() => { setComposeType("forward"); setComposeOpen(true); }}>
                <FontAwesomeIcon icon={faMailForward} className="me-2" /> Forward
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* THREAD */}
        <div className="mt-3">
          {threadMails.map((msg, i) => (
            <div key={msg.id} className="border rounded p-2 mb-3 bg-light">

              {/* Message header */}
              <div className="d-flex justify-content-between small text-muted mb-1">
                <div>{msg.from?.emailAddress?.address || "Unknown"}</div>
                <div>{new Date(msg.sentDateTime || msg.receivedDateTime).toLocaleString()}</div>
              </div>

              {/* BODY */}
              <div
                className="email-content"
                style={{ fontSize: "13px" }}
                dangerouslySetInnerHTML={{
                  __html: msg.body?.content || "",
                }}
              />

              {/* ATTACHMENTS */}
              {Array.isArray(msg.attachments) && msg.attachments.length > 0 && (
                <div className="mt-2">
                  {msg.attachments.map((att, idx) => {
                    if (att.mime?.startsWith("image/")) {
                      return (
                        <div key={idx} className="mt-2 text-center">
                          <img
                            src={att.dataUrl}
                            alt={att.filename}
                            style={{ maxWidth: "100%", borderRadius: 6, cursor: "pointer" }}
                          />
                          <div>
                            <a
                              href={att.dataUrl}
                              download={att.filename}
                              className="btn btn-sm btn-outline-secondary mt-1"
                            >
                              📎 {att.filename}
                            </a>
                          </div>
                        </div>
                      );
                    }

                    if (att.mime === "application/pdf") {
                      return (
                        <div key={idx} className="mt-2">
                          <iframe
                            src={att.dataUrl}
                            style={{ width: "100%", height: 300 }}
                            title={att.filename}
                          />
                          <a
                            href={att.dataUrl}
                            download={att.filename}
                            className="btn btn-sm btn-outline-secondary mt-1"
                          >
                            📄 {att.filename}
                          </a>
                        </div>
                      );
                    }

                    return (
                      <div key={idx} className="mt-1">
                        <a
                          href={att.dataUrl}
                          download={att.filename}
                          className="btn btn-sm btn-outline-secondary"
                        >
                          📎 {att.filename}
                        </a>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* QUICK REPLY */}
        <div className="mt-auto pt-2 border-top">
          <textarea
            className="form-control mb-2"
            rows="3"
            placeholder="Reply..."
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
          />
          <button
            className="btn btn-primary btn-sm"
            disabled={!replyText.trim()}
            onClick={sendReply}
          >
            Send
          </button>
        </div>
      </>
    )}
  </div>
</div>

        </div>{" "}
      </div>
    </>
  );
}
